import { AnimatePresence, motion } from 'framer-motion'
import React, { useState } from 'react'
import { FaEnvelope, FaPhone, FaCalendarAlt, FaMapMarkerAlt, FaUniversity, FaUser, FaCreditCard, FaClock } from "react-icons/fa";
// import { BsCheckCircleFill } from "react-icons/bs";
import ImageWithFallback from '../../../../../../components/ImageWithFallback';

import { FaStar } from "react-icons/fa"
import { MdAssignmentInd, MdDescription, MdCheckCircle, MdSchool, MdCake, MdPersonSearch, MdEmail, MdPhone, MdWc, MdHome, MdWork, MdLocationOn, MdWarning, MdOutlineWarning } from "react-icons/md";
import { BsExclamationCircle, BsFillCircleFill } from "react-icons/bs"
import { CgArrowLeft, CgArrowRight , CgClose} from 'react-icons/cg'

import { FaBolt } from 'react-icons/fa'; // Importer l'icône de l'éclair
// import InterviewList from '../Cards/InterviewCard';
// import ReviewCard from '../Cards/ReviewCard';
// import JobApplicationCard from '../../../../../../recruiter/components/Cards/JobApplicationCard';
import { PATH_END_POINT } from '../../../../../../../../api'
import { isExpired } from '../../../../../../../utils/Func';
import { GrStatusWarning } from 'react-icons/gr';


const StudentModal = ({show =false, onClose, data , item}) => {

    const [activeStep, setActiveStep] = useState(1);
    const [activeTab, setActiveTab] = useState("Entretien");

    const buttons = [
      { label: "Candidature", icon: <MdAssignmentInd className="text-lg" /> },
      { label: "Note", icon: <MdDescription className="text-lg" /> },
          { label: "Entretien", icon: <MdCheckCircle className="text-lg" /> },
    ];

    const steps = [
      { id: 1, title: "Details", subtitle: "Some info about you.", icon: <FaUser /> },
      { id: 2, title: "Address", subtitle: "Where we sending it?", icon: <FaMapMarkerAlt /> },
      { id: 3, title: "Payment", subtitle: "Show us the money.", icon: <FaCreditCard /> },
    ];

    // const { user, user: { candidate_profile: profile } } = data;

  return (
    <>
        <AnimatePresence>
    {
        show && (
    
        <motion.div 
        initial={{ opacity: 0.8  }}
        animate={{opacity: 1}}
        exit={{ opacity: 0.8 }}
        className="fixed ease-in duration-200 z-40 bg-gray-900/10 top-0 bottom-0 left-0 right-0 flex justify-end backdrop-blur-sm backdrop-filter">
        <motion.div
        // Animation pour l'apparition
        initial={{ opacity: 0.8, right: "-100%", y: 20 }}
        animate={{ opacity: 1, right: 0, y: 0 }}
        exit={{ opacity: 0.8, right: "-100%", y: 20 }}
        transition={{ type: "spring", stiffness: 130, damping: 20 }}
        className="fixed  overflow-y-auto overflow-x-hidden bg-white w-full lg:w-1/2 xl:w-[60%] min-h-full lg:rounded-s-2xl drop-shadow-lg max-h-screen pt-4 pb-6"
        >
            <div className="pb-4 px-6 border-b flex justify-between mb-4">
                <div className="flex items-center gap-2">
                <button className="border rounded-full p-2 hover:bg-gray-50">
                <CgArrowLeft></CgArrowLeft>
                </button>
                <button className="border rounded-full p-2 hover:bg-gray-50">
                <CgArrowRight/>
                </button>
                <span className="text-sm text-gray-500">
                    Page 1 sur {data?.applications?.length}
                </span>
                </div>

                <button onClick={onClose} className="border rounded-full p-2 hover:bg-gray-50">
                <CgClose/>
                </button>
               
            </div>
             <div className="">


    <div className="w-full ">
      <div className="flex items-center justify-between border-b pb-6  px-6" >
        <div className="flex items-center gap-4">
          <ImageWithFallback
            src={PATH_END_POINT+ data?.user?.photo}
            alt="Profil"
            defaultType='user'
            className="w-16 h-16 rounded-full object-cover"
          />
          <div>
            <h2 className="text-lg font-semibold">{data?.user?.name}</h2>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              
              <div className="flex items-center gap-1 bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs">
                <BsFillCircleFill className="text-green-500 w-2 h-2" />
                <span>Active</span>
              </div>
            </div>
            <div className="text-xs text-gray-500 mt-1 grid grid-cols-3 w-full gap-4  sm:gap-6">
              <div><span className="font-semibold">Origine:</span> {data?.job_title}</div>
              <div><span className="font-semibold">Postulé le:</span> {data?.created_at}</div>
              <div><span className="font-semibold">Poste:</span> {data?.user?.candidate_profile?.current_job}</div>
            </div>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <button className="bg-gray-900 text-white p-3 rounded-lg flex items-center gap-2 hover:bg-gray-800">
            <FaEnvelope />
          </button>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-24 mx-6">
        {/* Informations générales */}
        <div className="mt-6 divide-y">
          <InfoLine name="Email" text={data?.user.email} />
          <InfoLine name="Téléphone" text={data?.user?.candidate_profile?.phone} />
          <InfoLine name="Adresse" text={data?.user?.candidate_profile?.address} />
          <InfoLine name="Date de naissance" text={data?.user?.candidate_profile?.date_birth} />
          <InfoLine name="Genre" text={data?.user?.candidate_profile?.gender} />
        </div>

        {/* Carrière */}
        <div className="mt-6 divide-y">
          <InfoLine name="Niveau d'étude" text={data?.user?.candidate_profile?.level} />
          <InfoLine name="Diplôme le plus élevé" text={data?.user?.candidate_profile?.highest_diploma} />
          <InfoLine name="Poste actuel" text={data?.user?.candidate_profile?.current_job} />
          <InfoLine name="Entreprise" text={data?.user?.candidate_profile?.work_at} />
          <InfoLine 
            name="Disponibilité" 
            text={data?.user?.candidate_profile?.is_avalaible ? "Disponible" : "Non disponible"} 
          />
        </div>
      </div>


    </div>
      
    <div className=" px-6 mt-6 ">

    <CardRow trainingData={item}/>
 

    </div>     

    </div>

        </motion.div>
        </motion.div>)
    }
   </AnimatePresence>
    </>
  )
}


const StepIndicator= ({ currentStep }) => {
    const steps = [
        { title: "Nouveau" },
        { title: "Sélectionné" },
        { title: "Entretien" },
        { title: "Recruté" },
        { title: "Refusé" },
      ];
      
    return (
      <div className="w-full">
        {/* <p className='text-sm mb-2'>Etat actuel</p> */}
        <ol className="grid grid-cols-5 divide-x divide-gray-100 overflow-hidden rounded-lg border border-gray-100 text-sm text-gray-500">
          {steps.map((step, index) => {
            const isCompleted = (index + 1) < currentStep;
            const isCurrent = index + 1 === currentStep;
  
            return (
              <li
                key={index}
                className={`relative flex items-center justify-center gap-2 p-4 ${
                  isCurrent ? "bg-[#b4ff92] text-black" :
                  isCompleted ? "bg-primary-beige text-black" :
                  "bg-white"
                }`}
              >
                {/* Flèche à gauche sauf pour la première étape */}
                {index !== 0 && (
                  <span
                    className={`absolute -left-2 top-1/2 hidden size-4 -translate-y-1/2 -rotate-45 z-20   sm:block  border border-gray-100 border-t-0 border-l-0 
                  
                    ${
                        ( (index) < currentStep) ? "bg-primary-beige " :
                        ( index === currentStep) ? " bg-[#b4ff92]" :
                        "bg-white"
                      }
                    `}
                  />
                //     //     ${
                    //   isCompleted ? "bg-primary-beige" : "bg-white"
                    // }
                )}
  
                <p className="leading-none">
                  <strong className="block font-medium">{step.title}</strong>
                </p>
  
                {/* Flèche à droite sauf pour la dernière étape */}
                {index !== steps.length - 1 && (
                  <span
                    className={`absolute -right-2 top-1/2 hidden size-4 -translate-y-1/2 rotate-45  sm:block  ${
                      isCurrent ? "bg-[#b4ff92]" :
                      isCompleted ? "bg-primary-beige" :
                      "bg-white"
                    }`}
                  />
                )}
              </li>
            );
          })}
        </ol>
      </div>
    );
  };
export default StudentModal


const InfoRow =({ icon: Icon, label, value, isBlue=false }) =>{
  return (
    <div className= "flex items-center text-nowrap text-sm gap-2 mb-2">
      <Icon className="size-4 text-gray-500" />
      <span className="font-medium">{label}</span>
      <span className={ isBlue ? "ml-auto text-blue-600 px-2 py-1 border rounded-full border-blue-300" : "ml-auto"}>{value}</span>
    </div>
  );
}

const InfoLine = ({ name, text }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-5 py-3">
      <p className="col-span-2 font-medium text-gray-400">{name} :</p> 
      <p className="col-span-3 overflow-hidden text-ellipsis">{text || "N/A"}</p>
    </div>
  );
};

// import React from 'react';

function Card({ trainingData }) {
  const color =  isExpired(trainingData.training_end_at) ? "red": "blue"

  return (
    <div className={` drop-shadow-md rounded-lg shadow p-4 w-full border-l-4 border-${color}-500 ${color === "red" ? "bg-[#fff8f8]" : "bg-white"}`}>
      {/* En-tête de la carte */}

      <div className="flex items-center divide-x-2">
        <span className="text-xl font-semibold text-gray-400 pr-4">#1</span>
      {/* {trainingData.hadCertification && */}
      <div className={`flex items-center  pl-4 text-${color}-500`}>
        {color === "blue" ?   <FaBolt/> :   <BsExclamationCircle />}
      
      <span className="ml-2 text-sm ">{isExpired(trainingData.training_end_at) ? "Expiré": "Actif"}</span>
      </div>
    {/* } */}
      </div>
      <div className="flex items-center text-start justify-between mb-4">
          <span className="font-semibold text-lg">{trainingData.title}</span>
          
      </div>
        <ImageWithFallback src={PATH_END_POINT+ trainingData.image} alt={ PATH_END_POINT+ trainingData.image} className="w-full h-44 object-cover rounded-lg mb-4" />
      <div className="flex justify-between mb-4 text-xs text-gray-600">
        <span>Début: {trainingData.training_start_at}</span>
        <span>Fin: {trainingData.training_end_at}</span>
      </div>

      <div className="relative h-1 bg-gray-200 rounded-full mb-4">
        <div
          className={`absolute h-1 rounded-full ${color === "red" ? "bg-red-500" : "bg-blue-500"}`}
          style={{ width: `${trainingData.progress || 100}%` }}
        >          
        </div>
        <div className="relative  w-full flex justify-between items-center">
          <div className="bg-white size-4 border-4 border-gray-400 shadow-sm rounded-full -mt-1.5"></div>
          <div className= {`bg-white size-4 border-4  rounded-full  -mt-1.5 shadow-sm ${color === "red" ? "border-red-500" : "border-gray-700"}`}></div>
        </div>
      </div>

      {/* Informations du formateur */}
      <div className="flex items-center justify-between mt-4">
        <div className="flex items-center">
          <div className={`rounded-full w-8 h-8 flex items-center justify-center text-white ${color === "red" ? "bg-red-500" : "bg-blue-500"}`}>
            <span className="text-xs font-semibold">{trainingData.trainer_id}</span>
          </div>
          <div className="ml-2">
            <p className="text-sm font-semibold text-gray-700">{trainingData.location}</p>
            <p className="text-xs text-gray-500">{trainingData.fees} €</p>
          </div>
        </div>
        {/* Flèche vers la droite */}
        <button className="bg-gray-200 rounded-full w-8 h-8 flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
}

function CardRow({ trainingData }) {
  const color =  isExpired(trainingData.training_end_at) ? "red": "blue"

  return (
    <div className={` drop-shadow-md rounded-lg shadow p-4 w-full flex gap-4 border-l-4 border-${color}-500 ${color === "red" ? "bg-[#fff8f8]" : "bg-white"}`}>

      <ImageWithFallback src={PATH_END_POINT+ trainingData.image} alt={ PATH_END_POINT+ trainingData.image} className="w-full h-full object-cover rounded-lg " />
<div className="w-full">
<div className="flex flex-col justify-between h-full">
  <div>
  <div className="flex items-center divide-x-2">
        <span className="text-xl font-semibold text-gray-400 pr-4">#1</span>
      <div className={`flex items-center  pl-4 text-${color}-500`}>
        {color === "blue" ?   <FaBolt/> :   <BsExclamationCircle />}
      
      <span className="ml-2 text-sm ">{isExpired(trainingData.training_end_at) ? "Expiré": "Actif"}</span>
      </div>
    {/* } */}
      </div>
      <div className="flex items-center text-start justify-between mb-4">
          <span className="font-semibold text-lg">{trainingData.title}</span>
          
      </div>
  </div>
  <div>
  <div className="flex justify-between mb-4 text-xs text-gray-600">
        <span>Début: {trainingData.training_start_at}</span>
        <span>Fin: {trainingData.training_end_at}</span>
      </div>

      <div className="relative h-1 bg-gray-200 rounded-full mb-4">
        <div
          className={`absolute h-1 rounded-full ${color === "red" ? "bg-red-500" : "bg-blue-500"}`}
          style={{ width: `${trainingData.progress || 100}%` }}
        >          
        </div>
        <div className="relative  w-full flex justify-between items-center">
          <div className="bg-white size-4 border-4 border-gray-400 shadow-sm rounded-full -mt-1.5"></div>
          <div className= {`bg-white size-4 border-4  rounded-full  -mt-1.5 shadow-sm ${color === "red" ? "border-red-500" : "border-gray-700"}`}></div>
        </div>
      </div>

      {/* Informations du formateur */}
      <div className="flex items-center justify-between mt-4">
        <div className="flex items-center">
          <div className={`rounded-full w-8 h-8 flex items-center justify-center text-white ${color === "red" ? "bg-red-500" : "bg-blue-500"}`}>
            <span className="text-xs font-semibold">{trainingData.trainer_id}</span>
          </div>
          <div className="ml-2">
            <p className="text-sm font-semibold text-gray-700">{trainingData.location}</p>
            <p className="text-xs text-gray-500">{trainingData.fees} €</p>
          </div>
        </div>
        {/* Flèche vers la droite */}
        <button className="bg-gray-200 rounded-full w-8 h-8 flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
  </div>
</div>
       
      
</div>
      
    </div>
  );
}

